<template>
  <div class="search-protocols">
    <v-row class="search-protocols__row1">
      <v-col cols="12" sm="6" md="3" class="search-protocols__col">
        <div class="search-protocols__field search-protocols__field--date">
          <label class="search-protocols__label">Inserção Início</label>
          <div class="date-input-box">
            <v-datetime-field
              v-model="busca.dataInsercaoIni"
              only-date
              outlined
              dense
              hide-details
              class="input-prototype input-prototype--date"
            />
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="search-protocols__col">
        <div class="search-protocols__field search-protocols__field--date">
          <label class="search-protocols__label">Inserção Fim</label>
          <div class="date-input-box">
            <v-datetime-field
              v-model="busca.dataInsercaoFim"
              only-date
              outlined
              dense
              hide-details
              class="input-prototype input-prototype--date"
            />
          </div>
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="search-protocols__col">
        <div class="search-protocols__field">
          <label class="search-protocols__label">Protocolo</label>
          <v-text-field
            v-model="busca.protocolo"
            outlined
            dense
            hide-details
            background-color="#f5f5f5"
            placeholder="Digite o protocolo"
            prepend-inner-icon="mdi-clipboard-text-outline"
            class="input-prototype"
          />
        </div>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="search-protocols__col">
        <div class="search-protocols__field">
          <label class="search-protocols__label">Status</label>
          <v-select
            v-model="busca.status"
            :items="status"
            item-text="nome"
            item-value="cod"
            outlined
            dense
            hide-details
            background-color="#f5f5f5"
            placeholder="Selecione o status"
            class="input-prototype"
          >
            <template v-slot:no-data>
              <h5 class="pa-2">Sem dados no momento</h5>
            </template>
          </v-select>
        </div>
      </v-col>
    </v-row>

    <v-row class="search-protocols__row2" align="center">
      <v-col cols="12" md="5" lg="4" class="search-protocols__devedor search-protocols__col">
        <div class="search-protocols__field">
          <label class="search-protocols__label">Devedor</label>
          <v-autocomplete
            v-model="busca.devedor"
            :items="devedores"
            placeholder="Digite o nome do devedor"
            item-text="name"
            outlined
            dense
            hide-no-data
            item-value="id"
            prepend-inner-icon="mdi-account"
            :loading="isLoading"
            :search-input.sync="searchDevedor"
            :filter="(v) => v"
            flat
            hide-details
            clearable
            return-object
            background-color="#f5f5f5"
            class="input-prototype"
          >
            <template slot="selection" slot-scope="{ item }">
              {{ item.name }} - {{ formatarCpfCnpj(item.cpf_cnpj) }}
            </template>
            <template slot="item" slot-scope="{ item }">
              {{ item.name }} - {{ formatarCpfCnpj(item.cpf_cnpj) }}
            </template>
          </v-autocomplete>
        </div>
      </v-col>
      <v-col cols="12" md="7" lg="8" class="search-protocols__actions">
        <v-btn
          elevation="0"
          depressed
          rounded
          class="search-protocols__btn search-protocols__btn--buscar"
          @click="buscar()"
          :loading="ldgBuscar"
        >
          <v-icon small color="#FFD400">mdi-magnify</v-icon>
          <span class="btn-buscar-text">Buscar</span>
        </v-btn>
        <v-btn
          elevation="0"
          depressed
          outlined
          rounded
          class="search-protocols__btn search-protocols__btn--secondary"
          @click="gerar_Pdf"
          :loading="ldgPdf"
        >
          <v-icon small color="#424242">mdi-file-export</v-icon>
          <span class="btn-secondary-text">Imprimir PDF</span>
        </v-btn>
        <v-btn
          elevation="0"
          depressed
          outlined
          rounded
          class="search-protocols__btn search-protocols__btn--secondary"
          @click="limpar"
        >
          <v-icon small color="#424242">mdi-close-circle</v-icon>
          <span class="btn-secondary-text">Limpar</span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import helper from "../mixins/helper";

export default {
  components: {},
  name: "SearchProtocolsComponent",
  mixins: [helper],
  props: {
    url: {
      default: "protocolos",
    },
    perPage: {
      type: Number,
      default: 10,
    },
    // Período padrão da data de inserção: últimos N dias até hoje (null = sem período)
    periodoPadraoDias: {
      type: Number,
      default: null,
    },
  },
  data: () => ({
    status: [],
    states: [],
    dataRegister: [],
    search: null,
    ldgBuscar: false,
    searchDevedor: null,
    isLoading: null,
    devedores: [],
    ldgPdf: false,
    ultimaBusca: null,
    busca: {
      devedor: null,
      protocolo: null,
      status: null,
      bEmpresa: null,
      dataInsercaoFim: null,
      dataInsercaoIni: null,
    },
  }),
  created() {
    this.aplicarPeriodoPadrao();
  },
  mounted() {
    this.getStatus();
    this.buscar();
  },
  methods: {
    limpar() {
      this.busca.protocolo = null;
      this.busca.bEmpresa = null;
      this.busca.devedor = null;
      this.busca.status = null;
      // Antes zerava this.dataInsercaoFim (fora de busca) duas vezes e as datas nunca limpavam
      this.aplicarPeriodoPadrao();
    },

    /** Data local no formato do campo de data (yyyy-MM-dd), sem o desvio de fuso do toISOString. */
    formatarDataISO(data) {
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const dia = String(data.getDate()).padStart(2, "0");
      return `${data.getFullYear()}-${mes}-${dia}`;
    },

    aplicarPeriodoPadrao() {
      if (!this.periodoPadraoDias) {
        this.busca.dataInsercaoIni = null;
        this.busca.dataInsercaoFim = null;
        return;
      }
      const hoje = new Date();
      const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), hoje.getDate() - this.periodoPadraoDias);
      this.busca.dataInsercaoIni = this.formatarDataISO(inicio);
      this.busca.dataInsercaoFim = this.formatarDataISO(hoje);
    },

    getStatus() {
      this.$http.get("status_protocolo").then(
        (response) => {
          this.status = response.body.data;
        },
        (response) => {
          console.log(response);
          // error callback
        }
      );
    },

    gerar_Pdf() {
      this.ldgPdf = true;

      if (this.dataRegister.length > 0) {
        var obss = "";
        if (this.busca.dataInsercaoIni != null) {
          obss = `Data de inserção: ${this.busca.dataInsercaoIni} à ${this.busca.dataInsercaoFim} `;
        }
        this.$emit("emit-pdf", this.dataRegister, obss);
      } else {
        this.notificacao("Nada para exibir", "", "info");
      }
      this.ldgPdf = false;
    },

    notificacao(title, msg, icon) {
      this.$swal({
        toast: true,
        position: "center-end",
        showConfirmButton: false,
        timer: 3000,
        icon: icon,
        title: title,
        text: msg,
      });
    },
    getdataInsercaoIni(data) {
      this.busca.dataInsercaoIni = data;
    },
    getdataInsercaoFim(data) {
      this.busca.dataInsercaoFim = data;
    },
    /** Nova busca com os filtros atuais, sempre a partir da página 1. */
    buscar(perPage = this.perPage) {
      this.ultimaBusca = { ...this.busca };
      this.paginar(1, perPage);
    },

    /** Busca uma página da última busca feita (a API devolve o paginator do Laravel com o total). */
    paginar(page, perPage = this.perPage) {
      this.ldgBuscar = true;
      this.$emit("loading", true);
      const payload = { ...(this.ultimaBusca || this.busca), page };
      if (perPage) {
        payload.per_page = perPage;
      }
      this.$http.post(this.url, payload).then(
        (response) => {
          this.dataRegister = response.body.data;
          this.$emit("emit-busca", response.body.data, response.body);
          this.ldgBuscar = false;
          this.$emit("loading", false);
        },
        (response) => {
          console.log(response);
          this.ldgBuscar = false;
          this.$emit("loading", false);
        }
      );
    },
  },
  watch: {
    search(newValue) {
      this.isLoading = true;
      if (newValue != null) {
        if (newValue.length > 3) {
          this.$http.post("searchEmpresa", { bEmpresa: newValue }).then(
            (response) => {
              this.isLoading = false;
              this.states = response.body;
            },
            (response) => {
              console.log(response);
              // error callback
            }
          );
        }
      }
      this.isLoading = false;
    },
    searchDevedor(newValue) {
      if (newValue != null) {
        if (newValue.length > 3) {
          this.$http.post("searchDevedor", { busca: newValue }).then(
            (response) => {
              this.devedores = response.body;
            },
            (response) => {
              console.log(response);
              // error callback
            }
          );
        }
      }
    },
  },
};
</script>

<style scoped>
.search-protocols {
  margin-top: 4px;
}

.search-protocols__row1 {
  margin-bottom: 4px;
}

.search-protocols__row2 {
  margin-bottom: 8px;
}

/* Espaçamento interno das colunas */
.search-protocols__col {
  padding: 6px 8px;
}

/* Label em cima (igual protótipo) */
.search-protocols__field {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.search-protocols__label {
  font-family: 'Inter', sans-serif !important;
  font-size: 12px;
  font-weight: 500;
  color: #616161;
  margin-bottom: 4px;
  display: block;
  line-height: 1.3;
}

/* Esconde a label/legenda interna do Vuetify quando usamos label em cima */
.search-protocols__field .v-label {
  display: none !important;
}
.search-protocols__field .v-input__slot legend {
  width: 0 !important;
  padding: 0;
  margin: 0;
  font-size: 0;
  line-height: 0;
  overflow: hidden;
}

.search-protocols__actions {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  justify-content: flex-end;
  gap: 8px;
  padding-bottom: 6px;
}

@media (max-width: 959px) {
  .search-protocols__actions {
    justify-content: flex-start;
    margin-top: 8px;
  }
}

@media (max-width: 600px) {
  /* Buscar ocupa a linha toda; Imprimir e Limpar dividem a linha de baixo */
  .search-protocols__actions > .v-btn {
    flex: 1 1 0;
    min-width: 0 !important;
  }
  .search-protocols__actions > .search-protocols__btn--buscar {
    flex-basis: 100%;
  }
}

/* Botões flat */
.search-protocols__btn,
.search-protocols__btn::before {
  box-shadow: none !important;
}
.search-protocols__btn:not(.v-btn--disabled):hover {
  box-shadow: none !important;
}

/* =====================================================
   Inputs: fundo, borda e altura uniformes (36px)
   ===================================================== */
.search-protocols .v-input__slot {
  min-height: 36px !important;
  height: 36px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  margin-bottom: 0 !important;
  align-items: center !important;
  box-shadow: none !important;
  border-radius: 4px !important;
  background-color: #f5f5f5 !important;
}

/* v-select / v-autocomplete: selections sem empurrar o slot */
.search-protocols .v-select__selections {
  height: 34px !important;
  min-height: unset !important;
  flex-wrap: nowrap !important;
  align-items: center !important;
  overflow: hidden !important;
}

.search-protocols .v-select__selection {
  max-width: 100% !important;
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  margin: 0 !important;
}

.search-protocols .v-input__slot fieldset {
  border-color: #e0e0e0 !important;
  box-shadow: none !important;
}

.search-protocols .v-input--is-focused .v-input__slot fieldset {
  border-color: #9e9e9e !important;
  border-width: 1px !important;
}

.search-protocols input,
.search-protocols .v-select__selection,
.search-protocols .v-input__slot input {
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
  color: #212121 !important;
}

.search-protocols input::placeholder,
.search-protocols .v-select__slot input::placeholder {
  font-family: 'Inter', sans-serif !important;
  color: #9e9e9e !important;
  font-size: 13px !important;
}

/* Ícones internos centralizados */
.search-protocols .v-input__prepend-inner,
.search-protocols .v-input__append-inner {
  align-self: center !important;
  margin-top: 0 !important;
}

.search-protocols .v-input__prepend-inner .v-icon,
.search-protocols .v-input__append-inner .v-icon {
  color: #757575 !important;
  font-size: 18px !important;
}

/* Botão Buscar */
.search-protocols__btn--buscar {
  background-color: #0052A0 !important;
  color: #FFD400 !important;
  border: none !important;
}
.search-protocols__btn--buscar .btn-buscar-text,
.search-protocols__btn--buscar .v-icon {
  color: #FFD400 !important;
  font-weight: 700;
}

/* Botões secundários */
.search-protocols__btn--secondary {
  background-color: #fff !important;
  border: 1px solid #e0e0e0 !important;
  color: #424242 !important;
}
.search-protocols__btn--secondary .btn-secondary-text,
.search-protocols__btn--secondary .v-icon {
  color: #424242 !important;
  font-weight: 500;
}
</style>

<style>
/* =====================================================
   date-input-box: wrapper que carrega fundo + borda
   assim o background cobre 100% do retângulo visível
   independente do top:-5px do fieldset do Vuetify
   ===================================================== */
.date-input-box {
  background-color: #f5f5f5;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  height: 36px;
  min-height: 36px;
  display: flex;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.date-input-box:focus-within {
  border-color: #9e9e9e;
}

/* O v-datetime-field e seus wrappers internos ocupam toda a largura */
.date-input-box .v-datetime-field,
.date-input-box .v-datetime-field > * {
  width: 100%;
}

/* Remove a borda e o fundo do v-text-field interno (o wrapper cuida disso) */
.date-input-box .v-input__slot {
  background-color: transparent !important;
  box-shadow: none !important;
  margin-bottom: 0 !important;
}

.date-input-box .v-input__slot fieldset {
  border: none !important;
}

/* Remove margens extras do v-input */
.date-input-box .v-input {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.date-input-box .v-input__control {
  min-height: unset !important;
}

/* Label interna oculta */
.date-input-box .v-label {
  display: none !important;
}

.date-input-box .v-input__slot legend {
  display: none !important;
}

/* Ícone de calendário centralizado */
.date-input-box .v-input__append-inner {
  align-self: center !important;
  margin-top: 0 !important;
}

.date-input-box .v-input__append-inner .v-icon {
  color: #757575 !important;
  font-size: 18px !important;
}

/* Texto do input */
.date-input-box input {
  font-family: 'Inter', sans-serif !important;
  font-size: 13px !important;
  color: #212121 !important;
}

.date-input-box input::placeholder {
  font-family: 'Inter', sans-serif !important;
  color: #9e9e9e !important;
  font-size: 13px !important;
}
</style>